import { useState } from 'react';

const useSessionStorage = key => {
  const [value, setValue] = useState(() => {
    if (__SERVER__) {
      return null;
    }

    return JSON.parse(window.sessionStorage.getItem(key));
  });

  const setItem = newValue => {
    window.sessionStorage.setItem(key, JSON.stringify(newValue));
    setValue(JSON.parse(window.sessionStorage.getItem(key)));
  };

  return [value, setItem];
};

export default useSessionStorage;
